import { ActionButtonProps, Box, BoxProps, Form, Icon, Spacer } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { FC, useEffect, useState } from 'react'
import { CloseForm } from '../../components/CloseForm'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { getIdNameValue, getSchemaData, InstrumentTypes } from '../../utils/constants'
import { formData } from './formData'

interface InstrumentFormProps {
  data: any
  packageNames: any
  onSuccess: () => void
  isEditable: boolean
  isDeletable: boolean
  onClose: () => void
}

const InstrumentForm: FC<InstrumentFormProps> = (props: InstrumentFormProps) => {
  const { data, packageNames, onSuccess, isEditable, isDeletable, onClose } = props
  const { id } = data
  const [toggle, setToggle] = useState(false)

  const { add, update, deletePackage, message } = useStores((store) => ({
    add: store.packageToInstrument.add,
    update: store.packageToInstrument.update,
    deletePackage: store.packageToInstrument.deletePackage,
    message: store.message.getFormMessage(),
  }))

  const [lazyAdd, lazyAddHandler] = useLazyApiData(add)
  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(update)
  const [lazyDeletePackage, lazyDeletePackageHandler] = useLazyApiData(deletePackage)

  const onSubmit = (values: any) => {
    if (id) {
      lazyUpdate({
        id,
        packageName: values.packageName,
        instrument: values.instrument,
      })
    } else {
      lazyAdd({
        packageName: values.packageName,
        instrument: values.instrument,
      })
    }
  }

  useEffect(() => {
    if (lazyAddHandler.state === 'fulfilled' || lazyAddHandler.state === 'rejected') {
      onSuccess()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyAddHandler])

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled' || lazyUpdateHandler.state === 'rejected') {
      onSuccess()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyUpdateHandler])

  useEffect(() => {
    if (lazyDeletePackageHandler.state === 'fulfilled') {
      onSuccess()
      setToggle(false)
    }
    if (lazyDeletePackageHandler.state === 'rejected') {
      setToggle(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyDeletePackageHandler])

  const onDelete = () => {
    lazyDeletePackage({
      id,
      packageName: data.packageName,
      instrument: data.instrument,
    })
  }
  const onDismiss = () => {
    setToggle(false)
  }
  const deleteMapping = () => {
    setToggle(true)
  }

  const isLoading = () => {
    return lazyAddHandler.state === 'pending' || lazyUpdateHandler.state === 'pending'
  }

  const handleActions = ({ values, title, defaultActionButtonOnSubmit }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box paddingBottom={16} flexDirection="row">
        <ModalAlertView
          onPress={onDelete}
          show={toggle}
          onDismiss={onDismiss}
          title="Delete Package To Instrument"
          buttonTitle="Delete"
          message={`Is this final. This will delete mapping with ID ${id}.`}
          isLoading={lazyDeletePackageHandler.state === 'pending'}
        />
        {isEditable && <Button title={id ? 'Update' : title} onPress={handleOnPress} isLoading={isLoading()} />}
        <Spacer direction="horizontal" size={16} />
        {isDeletable && id && (
          <Box
            onPress={deleteMapping}
            bg="RED"
            underlayColor="ERROR"
            p={'MEDIUM'}
            justify={'center'}
            align={'center'}
            borderRadius={4}>
            <Icon id="DELETE" size={24} color="WHITE" />
          </Box>
        )}
      </Box>
    )
  }

  const getInstrumentData = () => {
    return getSchemaData(InstrumentTypes)
  }

  const getInitialInstruments = () => {
    const ins = data.instrument.split(',')
    let result
    if (ins && ins.length > 0) {
      result = ins.map((item: any) => `${getIdNameValue(item, InstrumentTypes)}`)
    }
    return result?.join(',')
  }

  return (
    <Box onPress={() => {}} {...styles.formContainer} overflow="auto">
      <CloseForm onClose={onClose} />
      <Form
        formData={formData(packageNames, getInstrumentData(), onSubmit, message)}
        actionButtons={handleActions}
        initialValues={
          id
            ? {
                packageName: data.packageName,
                instrument: getInitialInstruments(),
              }
            : {}
        }
      />
    </Box>
  )
}

export { InstrumentForm }

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    height: '100vh',
    overflow: 'auto',
    bg: 'WHITE',
    padding: 'MEDIUM',
  } as BoxProps,
}
